import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Button } from './ui/button';
import { Menu, X, Sparkles, User, LogOut } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

const Header = ({ onEnrollClick }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const { user, login, logout, loading } = useAuth();
  const location = useLocation();

  const navLinks = [
    { label: 'Syllabus', href: '/syllabus' },
    { label: 'Instructors', href: '/instructors' },
    { label: 'Pricing', href: '/pricing' },
    { label: 'About', href: '/about' },
    { label: 'Contact', href: '/contact' },
  ];

  const isLandingPage = location.pathname === '/';

  const handleNavClick = (href) => {
    setMobileMenuOpen(false);
    if (href.startsWith('#') && isLandingPage) {
      const element = document.querySelector(href);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  return (
    <header className="nav-header">
      <Link to="/" className="nav-logo">
        <Sparkles className="logo-icon" />
        <span className="logo-text">WSafe AI ML</span>
      </Link>

      {/* Desktop Navigation */}
      <nav className="nav-links-desktop">
        {navLinks.map((link) => (
          <Link
            key={link.label}
            to={link.href}
            className="nav-link"
          >
            {link.label}
          </Link>
        ))}
      </nav>

      <div className="nav-actions">
        {loading ? null : user ? (
          <div className="user-menu">
            <div className="user-info">
              {user.picture ? (
                <img src={user.picture} alt={user.name} className="user-avatar" />
              ) : (
                <div className="user-avatar-placeholder">
                  <User size={16} />
                </div>
              )}
              <span className="user-name">{user.name?.split(' ')[0]}</span>
            </div>
            <button className="logout-btn" onClick={logout} title="Logout">
              <LogOut size={18} />
            </button>
          </div>
        ) : (
          <>
            <button className="nav-link login-btn" onClick={login}>
              Sign In
            </button>
            <Button 
              className="btn-primary nav-cta"
              onClick={onEnrollClick}
            >
              Enroll Now
            </Button>
          </>
        )}
        
        {/* Mobile Menu Toggle */}
        <button 
          className="mobile-menu-toggle"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-label="Toggle menu"
        >
          {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile Navigation */}
      {mobileMenuOpen && (
        <div className="mobile-nav">
          {navLinks.map((link) => (
            <Link
              key={link.label}
              to={link.href}
              className="mobile-nav-link"
              onClick={() => setMobileMenuOpen(false)}
            >
              {link.label}
            </Link>
          ))}
          {user ? (
            <div className="mobile-user-section">
              <div className="mobile-user-info">
                <span>Signed in as {user.name}</span>
              </div>
              <Button 
                className="btn-secondary mobile-cta"
                onClick={() => {
                  logout();
                  setMobileMenuOpen(false);
                }}
              >
                <LogOut size={16} /> Sign Out
              </Button>
            </div>
          ) : (
            <>
              <button 
                className="mobile-nav-link"
                onClick={() => {
                  login();
                  setMobileMenuOpen(false);
                }}
              >
                Sign In
              </button>
              <Button 
                className="btn-primary mobile-cta"
                onClick={() => {
                  onEnrollClick();
                  setMobileMenuOpen(false);
                }}
              >
                Enroll Now
              </Button>
            </>
          )}
        </div>
      )}
    </header>
  );
};

export default Header;
